import { render, staticRenderFns } from "./SelectPersonnelClient.vue?vue&type=template&id=2431773c&scoped=true&"
import script from "./SelectPersonnelClient.vue?vue&type=script&lang=js&"
export * from "./SelectPersonnelClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431773c",
  null
  
)

export default component.exports